/**
 * Feature flags.
 *
 * Each flag resolves in this order:
 *   1. localStorage override (`ss-flag-<name>` = "1" or "0") — for dev/QA
 *   2. Vite env var (`VITE_FLAG_<NAME>` = "true"/"false")
 *   3. Default value
 *
 * The localStorage override is set via the browser console:
 *   localStorage.setItem('ss-flag-users-access', '1')
 *   localStorage.removeItem('ss-flag-users-access')
 */

const FLAGS = {
  // Phase 3 of the user/org consolidation. The new "Users & Access" screen
  // replaces Organizations users / Team / Org Managers / Sales Team / OrgOwners.
  // Default: superadmin-only via the role gate inside the route, but the flag
  // also lets us hide it entirely until we're ready to roll out org owners.
  'users-access': true,
};

export function isFlagOn(name) {
  if (typeof window !== 'undefined') {
    const override = window.localStorage?.getItem(`ss-flag-${name}`);
    if (override === '1') return true;
    if (override === '0') return false;
  }
  const envKey = `VITE_FLAG_${name.toUpperCase().replace(/-/g, '_')}`;
  const envVal = import.meta.env?.[envKey];
  if (envVal === 'true') return true;
  if (envVal === 'false') return false;
  return FLAGS[name] ?? false;
}
